export default __webpack_public_path__ + "static/default-a-155bf24f9ed26fcd83d21c7574d41dbf.png";